/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem } from '@molecules';

import ItemFooter from './ItemFooter';

const Item = ({ className, module, previewImg, errors }) => {
  return (
    <InfoItem.WithError error={errors} size="large" image={previewImg} description={module.content.title}>
      Live Blog
    </InfoItem.WithError>
  );
};

Item.Footer = ItemFooter;

export default Item;
